import Loading from '@/components/widget/Loading';
import Info from '@/components/subscriptions/Info';
import SubscriptionService from '@/services/SubscriptionService';
export default {
  name: 'Cancel',
  props: {
    subscription: Object
  },
  components: {
    Loading,
    Info
  },
  data() {
    return {
      openModal: false,
      loading: false
    };
  },
  methods: {
    toggleAutoRenew(e) {
      e.preventDefault();
      if (this.loading) {
        return false;
      }
      this.loading = true;
      SubscriptionService.cancel({
        subscription_id: this.subscription.id
      }).then(response => {
        if (response && response.data && response.data.success) {
          this.$nextTick(() => {
            this.$bvModal.hide('subscription-cancel-modal');
          });
          this.$aim.notify(response);
          this.$emit('refresh');
        } else {
          this.$aim.error(response);
        }
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    isCancelled() {
      return +this.subscription.autorenew !== 1 && this.subscription.cancel === 1;
    },
    actionName() {
      return this.isCancelled ? 'Renew' : 'Cancel';
    }
  }
};